import { localisedValue } from "utils"

const countriesTransformer = response => {
    const countries = response?.countries?.map(e => ({
        ...e,
        key: e?.id,
        label: localisedValue({ object: e, key: "name" }),
        value: e?.id?.toString(),
      }))
      return countries
  }
  
  export default countriesTransformer